import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { stateIsLoading } from '@guryou/redux';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const auth = useSelector(state => state.auth);

  return (
    <Route
      {...rest}
      render={props => {
        const isLoading = stateIsLoading(auth);
        const user = auth?.data;

        if (isLoading) {
          return (
            <div className="flex h-screen items-center justify-center">
              <p>Loading...</p>
            </div>
          );
        }

        if (!user?.userId) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location },
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};

export default PrivateRoute;
